if (window.__POWERED_BY_QIANKUN__) {
  window['custom-document-write'] = {
    'Document.prototype.write': Document.prototype.write,
  }

  const proxy = {
    apply(_target, _thisArg, argArray) {
      for (const arg of argArray) {
        const template = document.createElement('template')
        template.innerHTML = arg
        for (const childNode of template.content.childNodes) {
          // 不能使用 childNode 作为 document.head.appendChild 的参数
          // 因为乾坤内部会对 document.head.appendChild 传入的参数进行判断
          // 必须是通过 document.createElement 创建的元素才会被乾坤处理, 否则会视为主系统创建的元素, 添加到主系统的 <head /> 中
          const sandboxNode = document.createElement(childNode.tagName)
          Array.from(childNode.attributes).forEach((attr) => {
            sandboxNode.setAttribute(attr.name, attr.value)
          })
          sandboxNode.textContent = childNode.textContent
          sandboxNode.innerHTML = childNode.innerHTML
          if (
            sandboxNode instanceof HTMLScriptElement ||
            sandboxNode instanceof HTMLLinkElement ||
            sandboxNode instanceof HTMLStyleElement
          ) {
            document.head.appendChild(sandboxNode)
          } else {
            document.body.appendChild(sandboxNode)
          }
        }
      }
      return null
    },
  }
  Document.prototype.write = new Proxy(Document.prototype.write, proxy)

  // 清理函数, unmount 时调用, 防止污染全局
  window['custom-document-write'].cleanup = function () {
    Document.prototype.write = this['Document.prototype.write']
  }

  // 外部 js 文件只在第一次 mount 时执行, 后续 re-mount 不会执行, 导致 cleanup 后无法恢复
  window['custom-document-write'].reinstall = function () {
    // 判断是否被 cleanup 了, 防止重复代理
    if (Document.prototype.write === this['Document.prototype.write']) {
      Document.prototype.write = new Proxy(Document.prototype.write, proxy)
    }
  }
}
